<template>
    <div class="taskList spackage padding-20 bgc box-shadow">
        <div class="task_info_box flex_box">
            <div class="task_info_left_box flex_box">
                <img :src="eventInfo.coveratturlid" alt="">
                <div class="task_info">
                    <p>{{eventInfo.title}}</p>
                    <p>{{eventInfo.eventdesp}}</p>
                    <!-- <p>华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训 华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训华扬资本董秘培训培训</p> -->
                    <p :class="statusClass(eventInfo.status)">{{statusText(eventInfo.status)}}</p>
                </div>
            </div>
            <div class="task_info_right_box flex_box">
                <el-button v-if="eventInfo.status === 10 && eventInfo.onlinetype === 2" @click="handAddTask" type="primary">手动生成任务</el-button>
            </div>
            
        </div>
        <div class="task_list_table_box">
            <el-table :data="taskListData" style="width: 100%">
                <el-table-column prop="innerid" label="任务ID" align='center'></el-table-column>
                <el-table-column prop="begintime" label="开始时间" align='center' width="200"></el-table-column>
                <el-table-column prop="endtime" label="结束时间" align='center' width="200"></el-table-column>
                <el-table-column prop="viewcount" label="浏览量" align='center'></el-table-column>
                <el-table-column prop="ordersucccount" label="成交量" align='center'></el-table-column>
                <el-table-column prop="totalincome" label="销售额" align='center'></el-table-column>
                <el-table-column prop="finalrebatrate" label="最终折扣" align='center'></el-table-column>
                <el-table-column label="是否核算" align='center'>
                    <template slot-scope="scope">
                        <span>{{scope.row.isfinishrebat === 0 ? '未核算' : '已核算'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="任务状态" align='center'>
                    <template slot-scope="scope">
                        <span :class="statusClass(scope.row.status)">{{statusText(scope.row.status)}}</span>
                        <!-- <span>{{scope.row.status}}</span> -->
                    </template>
                </el-table-column>
                <el-table-column label="操作" align='center'>
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status === 30 && scope.row.isfinishrebat === 0" @click="taslSettle(scope.row)" type="text">任务结算</el-button>
                        <el-button v-if="scope.row.status === 10 || scope.row.status === 11" type="text" @click="suspended(scope.row)">{{scope.row.status === 10 ? '暂停' : '恢复'}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="getTaskList"></page>
        </div>
    </div>
</template>

<script>
import {getEventTaskInfoList, getSimpleEventDetail, suspendedTask, createAgbEventTaskInfo, agbEventTaskSettlement} from 'api/cPurchaseApi'
import Page from 'base/page/page'
import {initPage} from 'common/js/mixin'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: "TaskList",
    mixins: [initPage],
    data() {
        return {
            eventInfo: {},
            total: 0,
            taskListData: []
        }
    },
    mounted() {
        this.findEvent()
        this.getTaskList()
    },
    methods: {
        // 手动生成任务
        handAddTask() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            createAgbEventTaskInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.getTaskList()
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 查询单个活动详情
        findEvent() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getSimpleEventDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.eventInfo = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取活动任务列表Data
        getTaskList() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getEventTaskInfoList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.taskListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // searchClick() {
        //     this.$message.success(`${this.page.page}`)
        // },
        // 任务结算
        taslSettle(value) {
            // value.innerid = 1111111111111
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                taskinnerid: value.innerid
            }
            agbEventTaskSettlement({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('任务结算成功！')
                    value.isfinishrebat = 1
                    // this.getTaskList()
                },
                error: data => {
                    this.$message.error(data.msg)
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 暂停、恢复任务状态
        suspended(value) {
            // console.log(value)
            // this.$message.success(`暂停按钮!!`)
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                taskinnerid: value.innerid,
                status: value.status === 10 ? '11' : '10'
            }
            suspendedTask({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.getTaskList()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        statusText(value) {
            if (value === 0) {
                return '未开始'
            } else if (value === 10) {
                return '进行中'
            } else if (value === 11) {
                return '暂停中'
            } else if (value === 30) {
                return '已结束'
            }
        },
        statusClass(value) {
            if (value === 0) {
                return 'wks'
            } else if (value === 10) {
                return 'jxz'
            } else if (value === 11) {
                return 'ztz'
            } else if (value === 30) {
                return 'yjs'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
    .taskList{
        .flex_box{
            display: flex;
        }
        .wks {
            color: #F56C6C;
        }
        .jxz {
            color: #67C23A;
        }
        .ztz {
            color: #E6A23C;
        }
        .yjs {
            color: #606266;
        }
        .task_info_box{
            overflow: hidden;
            padding: 22px 20px;
            background-color: #FAFAFA;
            justify-content: space-between;
            .task_info_left_box{
                img{
                    min-width: 180px;
                    width: 180px;
                    height: 102px;
                }
                .task_info{
                    overflow: hidden;
                    margin-left: 30px;
                    p{
                        margin-bottom: 10px;
                    }
                    p:nth-of-type(1){
                        color: #303133;
                        font-size:16px;
                        font-family:PingFangSC-Medium,PingFangSC;
                        font-weight: bold;
                        line-height:22px;
                    }
                    p:nth-of-type(2){
                        color: #606266;
                        font-size:15px;
                        line-height:21px;
                        max-width: 900px;
                        // background-color: pink;
                        // padding-right: 44%;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    p:nth-of-type(3){
                        // color: #67C23A;
                        font-size:14px;
                        font-family:PingFangSC-Regular,PingFangSC;
                        line-height:20px;
                        margin-bottom: 0;
                    }
                }
            }
            .task_info_right_box{
                align-items: center;
            }
        }
        .task_list_table_box{
            margin-top: 30px;
            .el-table__empty-block {
                min-height: 500px;
            }
            .el-table th>.cell {
                font-weight: bold!important;
                white-space: nowrap;
                font-size: 16px;
            }
        }
    }

</style>